import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import classnames from 'classnames';
import { format as currencyFormat } from 'currency-formatter';
import * as analytics from '../../services/analytics';
import './Passport360EnrollmentConfirmationView.css';

const propTypes = {
  client: PropTypes.object,
  quoteCheckout: PropTypes.object,
};

class Passport360EnrollmentConfirmationView extends PureComponent {
  componentDidMount() {
    analytics.page('Passport 360 - Confirmation');
  }

  get title() {
    const { actor, quote } = this.props;
    if (actor === 'broker') {
      return `${get(
        quote,
        'application.client.first_name'
      )}'s coverage is bound!`;
    } else {
      return 'Your coverage is bound!';
    }
  }

  get paymentTitle() {
    const { actor, quote } = this.props;
    if (get(quote, 'application.billing.billing_type') === 'platform_eft') {
      return `The policy binder has been emailed to you. The issued policy documents will be emailed to you within 7 business days.`;
    } else if (actor === 'broker') {
      return `An invoice has been mailed to ${get(
        quote,
        'application.client.first_name'
      )}.`;
    } else {
      return `The policy binder and invoice have been emailed to you. The issued policy documents will be emailed to you within 7 business days. Payment must be received within 31 days of the effective date to avoid an interruption in coverage.`;
    }
  }

  get cardFooter() {
    const { actor, broker, client, quote } = this.props;
    if (actor === 'broker') {
      return (
        <Fragment>
          <p className="Passport360EnrollmentConfirmationView-questionsInfo">
            The policy binder and invoice has been emailed to{' '}
            {client.person.first_name}.
          </p>
          <Link
            to={`/dashboard/clients/${client.id}`}
            className="btn btn-complete m-t-20"
          >
            Return to client details
          </Link>
        </Fragment>
      );
    } else {
      const brokerPhone =
        broker.phone_number || get(quote, 'broker.phone_number');
      const brokerEmail = broker.email || get(quote, 'broker.email');

      return (
        <Fragment>
          <h4 className="Passport360EnrollmentConfirmationView-questionsTitle">
            Have any questions?
          </h4>
          <p className="Passport360EnrollmentConfirmationView-questionsInfo">
            Contact your broker at {brokerPhone} or email{' '}
            <a className="text-complete" href={`mailto:${brokerEmail}`}>
              {brokerEmail}
            </a>{' '}
            for assistance.
          </p>
        </Fragment>
      );
    }
  }

  render() {
    const { quote, quoteCheckout } = this.props;
    return (
      <div className="Passport360EnrollmentConfirmationView row justify-content-center">
        <div className="col-md-5 p-t-30">
          <div className="Passport360EnrollmentConfirmationView-icon text-success">
            <i className="fas fa-shield-check" />
          </div>
          <h1 className="Passport360EnrollmentConfirmationView-heading text-success text-center semi-bold">
            {this.title}
          </h1>

          <div className="Passport360EnrollmentConfirmationView-clientDetails card m-t-20">
            <div className="Passport360EnrollmentConfirmationView-cardBlock card-block">
              <span className="fa-stack fa-2x fa-fw">
                <i
                  className="far fa-circle fa-stack-2x"
                  style={{ color: '#e6e6e6' }}
                />
                <i
                  className={classnames('fas fa-stack-1x', {
                    'fa-credit-card-front':
                      get(quote, 'application.billing.billing_type') ===
                      'platform_eft',
                    'fa-envelope':
                      get(quote, 'application.billing.billing_type') ===
                      'carrier_bill',
                  })}
                />
              </span>
              <h2 className="Passport360EnrollmentConfirmationView-cardTitle">
                {this.paymentTitle}
              </h2>
              <h3 className="Passport360EnrollmentConfirmationView-totalHeading">
                {get(quote, 'application.billing.billing_type') ===
                'platform_eft'
                  ? 'Paid'
                  : 'Total due'}
              </h3>
              <p className="Passport360EnrollmentConfirmationView-totalPrice">
                {currencyFormat(quoteCheckout.grandtotal, { code: 'USD' })}
              </p>
              {this.cardFooter}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Passport360EnrollmentConfirmationView.propTypes = propTypes;

export default Passport360EnrollmentConfirmationView;
